import { ListItem, ListItemButton, ListItemIcon, Typography } from "@mui/material";
import { Access } from "../../interfaces/auth.interface";
import { useTheme } from '@mui/material/styles';

import menuIcons from './menuIcons';

interface UserMenuInterface {
    menuSelected: Access | null;
    subMenuSelected: Access | null;
    onClick: (itemSelected: Access) => void
}


const UserSubMenu = ({menuSelected, subMenuSelected, onClick}: UserMenuInterface) => {

    const theme = useTheme();

    const hiddenMenuItems = ["Beneficios", "Administradores", "Documentos", "Áreas"];

    return (
        <>
        {menuSelected?.children?.filter((group: Access) => !hiddenMenuItems.includes(group.Name))
          .map((group, index) => {
            const MenuIcon = menuIcons[group.Name]
            
            return (
              <ListItem 
                key={group.Name} 
                disablePadding 
                sx={{ 
                  display: 'block', 
                  padding: 0,
                  ...group.urlPath === subMenuSelected?.urlPath 
                      ? {
                          backgroundColor: theme.s10palette.S10Greygrey350,
                          borderRadius: "0.25rem"
                      }
                      : {}
                }}
              >
                <ListItemButton
                  disableTouchRipple
                  sx={{
                    padding: "0.5rem",
                    height: "2.625rem",
                    // width: "3.3rem", 
                  }}
                  onClick={() => onClick(group)} 
                >
                  <ListItemIcon 
                    style={{minWidth: "0", marginRight: "0.5rem"}}
                  >
                    {MenuIcon 
                      ? <MenuIcon 
                        color={theme.s10palette.S10Greygrey100}
                        fontSize={"1.125rem"} 
                      /> 
                      : "¿?"
                    }
                  </ListItemIcon>
                  <Typography variant="subtitle2" color={theme.s10palette.S10Greygrey100} style={{textWrap: "wrap"}}>
                    {group.Name}
                  </Typography>
                </ListItemButton>
              </ListItem>
            );
        })}
        </>
    )

}

export default UserSubMenu;